import { IItem, ILocation, ItemLocation, ItemLocationEntity, ItemTable, LocationEntity } from "packable-common";

export class StorageItemTable extends ItemTable {
  // OVERRIDE
  onEntitiesGetSuccess(data: any): void {
    let storageItemRows = data.data.map((row: IItem) => {
      let suffix = "";
      if (row.itemLocation !== undefined && row.itemLocation !== null) {
        if (row.itemLocation.shippingStatus !== null) {
          suffix = row.itemLocation.shippingStatus;
        }
        if (row.itemLocation.storageStatus !== null) {
          suffix += "_" + row.itemLocation.storageStatus;
        }
      }
      return {
        ...row,
        itemLocationName: row.itemLocation?.locationType + "_" + suffix,
      };
    });
    data.data = storageItemRows;
    super.onEntitiesGetSuccess(data);
  }
  // OVERRIDE
  handleEntityAdd(entity: any): void {
    if (entity) {
      const itemLocation: ItemLocation = new ItemLocationEntity();
      entity.itemLocation = itemLocation;
      entity.itemLocationName = itemLocation.locationType + "_";
    }
    super.handleEntityAdd(entity);
  }
}

export default StorageItemTable;
